export const FormInputClass = (hasError) =>
  `w-full rounded-lg border px-3 py-2 text-sm bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary transition-colors ${
    hasError
      ? "border-red-400 focus:ring-red-400"
      : "border-gray-200 dark:border-gray-700 focus:border-primary"
  }`;
